import styled from "styled-components";
import React from "react";
import { useForm } from "react-hook-form";
import { relateAnswerFieldsGet } from "./RelateAnswerAction.logic";
import { useTopicRelateAnswer } from "../../provider/TopicRelateAnswer";
import { ReactRefI } from "type/common/ref.type";
import {
  useCorrectAnswerByLetter,
  useRelateAnswerAction,
} from "./hook/useRelateAnswerAction";
import RelateAnswerActionForm from "./component/RelateAnswerActionForm";
import AnswerCorrect from "./component/AnswerCorrect";
import { useLocalStorageValue } from "hooks/hook_util/local_storage/useLocalStorageEntry";
import { CHARACTER_EDIT_RELATE } from "constant/character/character.constant";

type RelateAnswerActionProps = {
  letter: string;
};

const RelateAnswerAction = ({ letter }: RelateAnswerActionProps) => {
  const { selector, action } = useTopicRelateAnswer();
  const relateAnswerActionFormMode = useLocalStorageValue(
    CHARACTER_EDIT_RELATE.RELATE_ANSWER_ACTION_FORM_MODE
  );
  const { handleSubmit, control } = useForm({
    defaultValues: relateAnswerFieldsGet(),
  });
  const relateContainRef: ReactRefI<string[]> = React.useRef<string[]>([]);
  const character = React.useMemo(() => selector.byLetter(letter), [letter]);
  const answerCorrect = useCorrectAnswerByLetter(letter);
  const containLength = React.useMemo(
    () =>
      character && character.relate?.contain
        ? character.relate.contain.length
        : 0,
    [character]
  );
  const [showAnswerForm, setShowAnswerForm] = React.useState<boolean>(
    relateAnswerActionFormMode === "show"
  );
  const [showCorrectAnswer, setShowCorrectAnswer] = React.useState<boolean>(
    relateAnswerActionFormMode !== "show"
  );
  const correctAnswerHandle = React.useCallback(
    () => setShowAnswerForm(false),
    [setShowAnswerForm]
  );
  const { relateAnswerCheckSend } = useRelateAnswerAction({
    correctAnswerHandle,
  });

  const onSubmit = (data: any) => {
    console.log("onSubmit", data);
    const answer = {
      pronounce: data.answer_pronounce ?? "",
      meaning: data.answer_meaning ?? "",
      contain: relateContainRef.current,
    };
    const correct = relateAnswerCheckSend(letter, answer);
    if (!correct) {
      setShowCorrectAnswer(true);
    }
  };

  return (
    <Div>
      {showAnswerForm && (
        <RelateAnswerActionForm
          control={control}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          relateContainRef={relateContainRef}
          containLength={containLength}
        />
      )}
      {showCorrectAnswer && (
        <AnswerCorrect letter={letter} answer={answerCorrect} />
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;

export default RelateAnswerAction;
